'use strict';

angular.module('ProductManageMentKuaishouModule', []).controller('productManageMentKuaishouCtrl', ['$scope', '$controller', 'editingMediatype',
    function($scope, $controller, editingMediatype) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.searchParams = { // 查询方法
                serviceid: 'mlf_kuaishouconfig',
                methodName: 'query',
                AccountName: '',
                PageSize: 100,
                CurrPage: 1
            };
            $scope.mediaName = '快手';
            $scope.accountKey = 'ACCOUNTID'; // 传给后台的帐号id字段
            $scope.mediaAccountKey = 'KUAISHOUACCOUNTID'; // 列表上帐号id字段
            $scope.rightsKey = 'kuaishouset.account'; // 权限位
            $scope.mediaType = 'kuaishou'; // 渠道名
            $scope.mediaTypeId = editingMediatype[$scope.mediaType]; // 渠道id
            $scope.rightsParams = { // 获取权限方法
                serviceid: 'mlf_metadataright',
                methodName: 'queryOperKeyOfKuaiShou',
                Classify: $scope.rightsKey
            };
            $scope.newAccountParams = { // 新建帐号方法
                serviceid: 'mlf_kuaishouconfig',
                methodName: 'saveKuaiShouAccount'
            };
            $scope.deleteAccountParams = { // 删除帐号方法
                serviceid: 'mlf_kuaishouconfig',
                methodName: 'deleteProducts'
            };
            $scope.reAuthorizeParams = { // 重新授权方法
                serviceid: 'mlf_kuaishouconfig',
                methodName: 'reAuthorize',
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            // 合并抖音控制器，实现复用
            $controller('productManageMentShortVideoCtrl', { $scope: $scope });
        }
    }
]);
